import { useCallback } from 'react';
import { updateShowSensitive } from '~/app/(default-layout)/s/[storyId]/_request/update-user-preference-sensitive';
const SESSION_STORAGE_KEY = 'sensitive-story-accepted';

export const useUpdateAcceptedSensitive = () => {
  const accept = useCallback(async (showAlways: boolean) => {
    try {
      if (showAlways) {
        await updateShowSensitive(true);
      }
      sessionStorage[SESSION_STORAGE_KEY] = true;
    } catch {
      // nop
    }
  }, []);

  return {
    accept,
  };
};
